import React, { useState } from 'react';
import { Heart } from 'lucide-react';

const Footer = () => {
  const [setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <footer className="bg-blue-900/95 backdrop-blur-md text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <Heart className="h-8 w-8 text-blue-300" />
              <span className="text-2xl font-bold">St. Alphonsa Charitable Organization</span>
            </div>
            <p className="text-blue-200 mb-4 max-w-md">
              Serving humanity with compassion since 2024. Creating lasting positive impact through comprehensive charitable services and community empowerment programs.
            </p>
            <div className="text-sm text-blue-300">
              <p>Registered Charity Organization</p>
              <p>Kerala, India | Est. 2024</p>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-blue-200">
              <li><button onClick={() => scrollToSection('about')} className="hover:text-white transition-colors">About Us</button></li>
              <li><button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors">Our Services</button></li>
              <li><button onClick={() => scrollToSection('about')} className="hover:text-white transition-colors">Mission & Vision</button></li>
              <li><button onClick={() => scrollToSection('contact')} className="hover:text-white transition-colors">Contact Us</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2 text-blue-200 text-sm">
              <li>Medical Bed Support</li>
              <li>Agricultural Assistance</li>
              <li>Mobility Equipment</li>
              <li>Educational Support</li>
              <li>Emergency Relief</li>
              <li>Community Development</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-blue-800 pt-8 text-center">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-blue-300 text-sm">
              © 2024 St. Alphonsa Charitable Organization. All rights reserved.
            </div>
            <div className="text-blue-300 text-sm">
              Made with ❤️ for humanity | Privacy Policy | Terms of Service
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
